import React from 'react';
import { useQuery } from '@apollo/client';
import { Loader } from '../../../components/Loader';
import Navbar from '../../../components/Navbar';
import EditEOneItemForm from '../../../components/RequestForms/EditEOneItemForm';
import { GET_EONE_ITEM_BY_ID } from '../api';

export const EditEOnePage = (props) => {
  const { loading, error, data } = useQuery(GET_EONE_ITEM_BY_ID, {
    variables: { id: parseInt(props.match.params.eOneId) },
  });

  if (loading)
    return (
      <div>
        <Navbar />
        <Loader />
      </div>
    );

  if (error) {
    return <div>error</div>;
  }
  if (data) {
    return (
      <div>
        <Navbar />
        <div className='m-4'>
          <EditEOneItemForm data={data} queryData={data} />
        </div>
      </div>
    );
  }
};
